import { PARTNER_LIST } from "../constants/actionTypes";

const defaultState = {
    data: [],
    total: 0,
    pager: { pageSize: 36, current: 1 },
    error: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PARTNER_LIST: {
            const error = !!action.error;
            const {
                send,
                payload: { total, data },
            } = action;

            const { pager } = send || {};
            const pagination = pager || state.pager;

            return {
                total: total || 0,
                pager: { ...pagination },
                data,
                error,
            };
        }
        default:
            return state;
    }
};
